import {addCustomCrop, editCustomCrop, getCropDetail, getcroplist, getcroptypelist} from '../../services/cropapi'

export default {
  state: {},
  mutations: {},
  actions: {
    getcroptypelist (store) {
      return getcroptypelist()
    },
    getcroplist (store, params) {
      return getcroplist(params)
    },
    addCustomCrop (store, params) {
      return addCustomCrop(params)
    },
    editCustomCrop (store, {cropId, params}) {
      return editCustomCrop(cropId, params)
    },
    getCropDetail (store, cropId) {
      return getCropDetail(cropId)
    }
  }
}
